module.exports = __webpack_public_path__ + "img/binance.7b2e7ab3.png";